import { getList } from "@/api/crud";
import { defaultParamsFormatter } from "@/components/select/utils";

export const getListForMultiSelect = async (loaderUrl: string) => { 
    const filter = defaultParamsFormatter('', 'title');
    
    try {
        const response = await getList (loaderUrl, { page: 1, items: 50 }, '', filter);
        const items = Array.isArray(response)
            ? response :
            response?.table?.rows ?? [];

        const list = items.map((item: any) => ({
            id: item.id,
            value: item.title,
        }));

        return list;
    } catch (error) {
        console.log(error);
    }
}